import { useScrollToSection } from "../hooks/ScrollContext";
import { Android, AndroidQR, BGDownload, BGDownloadMobile, IOS, IOSQR } from "../assets/images/image"

const Download = () => {
    const { scrollToSection } = useScrollToSection();
    return (
        <div className="w-full h-full">
            <div className="hidden md:flex items-start h-full">
                <div className="w-full h-full min-h-[620px] space-y-4 relative">
                    <div className="space-y-2 relative z-10">
                        <p className="text-[48px] font-light text-[#484848] text-center font-inter" data-reveal="up">Download <span className="font-bold">VIYUME</span></p>
                        <p className="text-[24px] font-bold text-[#484848] text-center font-inter" data-reveal="up">AI-Powered Flashcards for Effortless Learning</p>
                    </div>
                    <div className="flex items-center justify-center gap-[72px] relative z-10" data-reveal="up">
                        <div className="space-y-8">
                            <a href="https://play.google.com/store/apps/details?id=com.Viyume.flashcard" className="flex items-center justify-center cursor-pointer w-[326px] h-[80px] rounded-2xl bg-[#F5F6F6] shadow-button-download gap-x-8"
                                target="_blank" rel="noreferrer">
                                <img src={Android} alt="Android" className="w-[48px] h-[48px]" />
                                <p className="text-[14px] text-[#484848] font-inter">Get it on Google Play</p>
                            </a>
                            <img src={AndroidQR} alt="Android" loading="lazy" className="w-[96px] h-[96px] mx-auto" />
                        </div>
                        <div className="space-y-8">
                            <a
                                href="https://apps.apple.com/vn/app/viyume/id6751488343?l=vi"
                                className="flex items-center justify-center cursor-pointer w-[326px] h-[80px] rounded-2xl bg-[#F5F6F6] shadow-button-download gap-x-8"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={IOS} alt="iOS" className="w-[48px] h-[48px]" />
                                <p className="text-[14px] text-[#484848] font-inter">Download on the App Store</p>
                            </a>
                            <img src={IOSQR} alt="iOS" loading="lazy" className="w-[96px] h-[96px] mx-auto" />
                        </div>
                    </div>
                    <div className="absolute inset-0 z-0 pointer-events-none" data-parallax="0.1">
                        <img
                            src={BGDownload}
                            alt="Background"
                            className="w-full h-full"
                            loading="lazy"
                            style={{ transform: "translate(-30%, 15%) translate3d(0px, 0px, 0px) scale(0.7)" }}
                        />
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center gap-y-10 pt-6 md:hidden">
                <div className="w-full flex items-start px-4">
                    <div className="flex items-center w-full">
                        <span
                            className="text-[17px] font-normal font-inter text-[#484848] cursor-pointer hover:underline bg-[#D9D9D9] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]"
                            onClick={() => scrollToSection("home")}
                        >
                            Home
                        </span>
                        <div className="bg-[#FFD600] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]">
                            <span className="text-[17px] font-normal font-inter text-[#484848] mx-2">→</span>
                            <span className="text-[17px] font-bold font-inter text-[#484848]">
                                Download
                            </span>
                        </div>
                    </div>
                </div>
                <div className="space-y-2">
                    <p className="text-[24px] font-light text-[#484848] text-center font-inter" data-reveal="up">Download <span className="font-bold">VIYUME</span></p>
                    <p className="text-[14px] font-bold text-[#484848] text-center font-inter" data-reveal="up">AI-Powered Flashcards for Effortless Learning</p>
                </div>
                <div className="space-y-8" data-reveal="up">
                    <a href="https://play.google.com/store/apps/details?id=com.Viyume.flashcard" className="flex items-center justify-center cursor-pointer w-[326px] h-[80px] rounded-2xl bg-[#F5F6F6] shadow-button-download gap-x-8"
                        target="_blank" rel="noreferrer">
                        <img src={Android} alt="Android" className="w-[48px] h-[48px]" />
                        <p className="text-[14px] text-[#484848] font-inter">Get it on Google Play</p>
                    </a>
                    <img src={AndroidQR} alt="Android" loading="lazy" className="w-[96px] h-[96px] mx-auto" />
                </div>
                <div className="space-y-8" data-reveal="up">
                    <div className="flex items-center justify-center cursor-pointer w-[326px] h-[80px] rounded-2xl bg-[#F5F6F6] shadow-button-download gap-x-8">
                        <img src={IOS} alt="Android" className="w-[48px] h-[48px]" />
                        <p className="text-[14px] text-[#484848] font-inter">Download on the App Store</p>
                    </div>
                    <img src={IOSQR} alt="Android" loading="lazy" className="w-[96px] h-[96px] mx-auto" />
                </div>
                <img src={BGDownloadMobile} alt="Background" className="w-full h-full" loading="lazy" />
            </div>
        </div>
    )
}
export default Download